import { useRef, useState } from "react";
import * as S from "./ChatbotMessagesDisplay.style"
import { useMutation } from "@apollo/client";
import { MUTATION_CHAT_BOX } from "../../../../../../../../graphql/mutations/Chat";
import { useTranslation } from "react-i18next";
import useDoctorData from "../../../../../../../../hooks/useDoctorData";
import ZaialoadingPoints from "../../../../../../../zaiaComponents/zaiaLoadingPoints";
import ChatbotInput from "../../../../chatbotInput";

// import Message from "../../message";
import useUploadTempDoc from "../../../../../../../../hooks/useUploadTempDoc";
import useUploadTempSeveralDocs from "../../../../../../../../hooks/useUploadTempSeveralDocs";
import useFileProcessor from "../../../../../../../../hooks/useImageProcessor";
import ZaiaReaction from "../../../../../../../zaiaComponents/zaiaReaction";
import Message from "../../../../../../algorithms/components/message";
import MessageType from "../../../../messageType";

// pipes
import YesOrNo from "../../../../yesOrNo";

const bgChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/chat-background.svg`
const monacoChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-logo.svg`
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ChatbotMessagesDisplay({
  patientData,
  messages,
  setMessages,
  algorithm,
  handleSubmitSeveralFiles,
  handleSubmit,
  deleteDoc,
  tempDoc,
  tempDocs,
  dataDoc,
  dataDocs,
  severalImgs,
  fileInput,
  deleteDocs,
  errorLimit,
  botMessage,
  chatLoading,
  loading,
  error
}) {

  const element = document.getElementById("chatbot-container");
  const { t, i18n: { language } }= useTranslation("global");
  const { doctorData } = useDoctorData();

  const patientMessage = (msg, type) => {
    let allMessages = messages;
    allMessages.push(
      {
        id: Date.now(),
        message: msg,
        senderName: `${doctorData.name} ${doctorData.lastname}`,
        type: type
      }
    )
    setMessages([...allMessages])
  }

  const autoScroll = () => {
    if(element) element.scrollTop = element.scrollHeight - element.clientHeight;
  }


  return (
    <S.ChatbotMessagesDisplay>
      {
        !tempDoc && tempDocs.length === 0
        ? <>
          <div className="chatbot-container" id="chatbot-container">
            {
              messages.map((message, index) => (
                <div key={message.id}>
                  {
                    message.type === 'yesOrNo'
                    ? <YesOrNo
                      option={message.message}
                      noEditable={true}
                    />
                    : <Message
                      message={message.message}
                      option={message.type}
                      file={message.file}
                    />
                  } 
                  {
                    message.payload && Object.keys(message.payload).length > 0 
                    && 'items' in message.payload.fields
                    ? <MessageType
                        itemsList={message.payload.fields.items.listValue.values}
                        patientMessage={patientMessage}
                        botMessage={botMessage}
                        autoScroll={autoScroll}
                        message={message}
                        yesOrNoDisabled={messages[`${index + 1}`]?.type !== 'yesOrNo'}
                      /> 
                    : null
                  }
                </div>
              ))
            }
            { 
              chatLoading || loading
              ? <Message>
                <ZaialoadingPoints />
              </Message> 
              : null
            }
          </div>
        </>
        : <div className="file-selected">
          <div className="header">
            <div className="header__close"
              onClick={() => {
                algorithm === "prostate"
                ? deleteDocs()
                : deleteDoc();
                fileInput.current.value = null;
              }}
            >
              <i className="icon zaia-icono-cerrar"></i>
            </div>
            <div className="header__info">
              {/* <div className="header__img">
                <ZaiaImage img={selectedChat?.chatPhotoUser} alt="Zaia user" size={40} defaultImg={defaultChatGroup} rounded={true}/>
              </div>
              <div className="header__text">
                <div className="text">
                  {selectedChat?.chatNameUser}
                </div>
                <div className="text">
                  {selectedChat?.userToProcess ? P.dataTranslation(selectedChat?.userToProcess.process?.processName, language) : ""}
                </div>
              </div> */}
            </div>
          </div>
          {
            error || errorLimit ?
            <div className="error-reaction">
              <ZaiaReaction
                zaiaImg={logoZaiaAlert}
                widthimg="100px"
                text={errorLimit ? t("algorithms.errorLimitFiles") : t("chat.errorLoadingFile")}
                sizeText="20px"
                widthText="240px"
              />
            </div>
            : <>
              {
                algorithm === "prostate"
                ? <div className="files">
                  {
                    tempDocs.map((doc, index) => {
                      return(
                        <div className="file" key={index}>
                          <div className="file__preview">
                            {
                              doc?.type?.includes("image") 
                              ? <div className="file__img">
                                <img src={
                                  doc?.url || URL.createObjectURL(doc)
                                } alt="" />
                              </div>
                              : <div className="file__icon">
                                <i className="icon zaia-icon-file"></i>
                              </div>
                            }
                          </div>
                          <div className="file__title">
                            {doc?.name || dataDocs[index]?.name || "Archivo"}
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                : <div className="file">
                  <div className="file__preview">
                    {
                      tempDoc?.type?.includes("image") 
                      ? <div className="file__img">
                        <img src={
                          tempDoc?.url || URL.createObjectURL(tempDoc)
                        } alt="" />
                      </div>
                      : <div className="file__icon">
                        <i className="icon zaia-icon-file"></i>
                      </div>
                    }
                  </div>
                  <div className="file__title">
                    {tempDoc?.name || dataDoc?.name || "Archivo"}
                  </div>
                </div>
              }
            </> 
          }
        </div>        
      }
      <div className="chatbot-footer">
        <ChatbotInput
          handleSubmit={
            severalImgs
            ? handleSubmitSeveralFiles
            : handleSubmit
          }
          handleClickUpload={() => fileInput.current.click()}
          tempDocs={severalImgs ? tempDocs : [tempDoc]}
          filesSelectorActived={false}
        />
      </div>
    </S.ChatbotMessagesDisplay>
  );

}

export default ChatbotMessagesDisplay;
